/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2021-12-22 11:17:45
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-06-17 13:32:09
 */

import i18n from 'i18next';
import { getFramePositionInfo } from '@/3DEngine/render/utils/templatejsonUtils';


// 组件里面渲染尺寸文案
export const typeObj = {
  I: `I${i18n.t('caseShape.type')}`,
  L: `L${i18n.t('caseShape.type')}`,
  U: `U${i18n.t('caseShape.type')}`,
  H: `II${i18n.t('caseShape.type')}`,
};


export const lengthObj = {
  1: i18n.t('utils.l1'), 2: i18n.t('utils.l2'), 3: i18n.t('utils.l3'),
};
export const sizeText = (obj, sizeObj, cainettype = 'bottom') => {
  if (!sizeObj || !obj) { return ''; }

  const {
    type, len1, len2, len3,
  } = sizeObj;
  let sinkLocation = getFramePositionInfo(obj, 'sink')?.location;
  let stoveLocation = getFramePositionInfo(obj, 'stove')?.location;
  if (obj?.bottom?.type === 'H') {
    if (sinkLocation === 3) {
      sinkLocation = 2;
    }
    if (stoveLocation === 3) {
      stoveLocation = 2;
    }
  }

  const lengthTextObj = {
    top: {
      1: `(${i18n.t('utils.l1')})`,
      2: `(${i18n.t('utils.l2')})`,
      3: `(${i18n.t('utils.l3')})`,
    },
    bottom: {
      1: `(${i18n.t('utils.l1')})`,
      2: `(${i18n.t('utils.l2')})`,
      3: `(${i18n.t('utils.l3')})`,
    },
  };

  if (sinkLocation === stoveLocation) {
    lengthTextObj.bottom[stoveLocation] = i18n.t('utils.text1', { num: lengthObj[sinkLocation] });
    lengthTextObj.top[stoveLocation] = i18n.t('utils.text2', { num: lengthObj[sinkLocation] });
  } else {
    lengthTextObj.bottom[sinkLocation] = i18n.t('utils.text3', { num: lengthObj[sinkLocation] });
    lengthTextObj.top[stoveLocation] = i18n.t('utils.text4', { num: lengthObj[stoveLocation] });
    lengthTextObj.bottom[stoveLocation] = i18n.t('utils.text4', { num: lengthObj[stoveLocation] });
  }
  let text = '';
  text = `${typeObj[type]}${cainettype === 'top' ? i18n.t('other.top_ark')
    : i18n.t('other.bottom_ark')}/${len1}${i18n.t('cm')}
  ${lengthTextObj[cainettype][1]}`;


  if (type === 'L') {
    text += ` x ${len2}${i18n.t('cm')} ${lengthTextObj[cainettype][2]}`;
  } else if (type === 'H') {
    if (obj.bottom.type === 'U') {
      text += ` x ${len3}${i18n.t('cm')} ${lengthTextObj[cainettype][3]}`;
    } else {
      text += ` x ${len3}${i18n.t('cm')} ${lengthTextObj[cainettype][2]}`;
    }
  } else if (type === 'U') {
    text += ` x ${len2}${i18n.t('cm')} ${lengthTextObj[cainettype][2]} x 
    ${len3}${i18n.t('cm')} ${lengthTextObj[cainettype][3]}`;
  }
  return text;
};

// 柜型格式化方法
export const typeFomatter = (size) => {
  if (!size) { return ''; }
  const { top, bottom } = size;
  // eslint-disable-next-line no-nested-ternary
  return `${bottom.type === 'H' ? 'II' : (bottom.type === 'U_S' ? 'U' : bottom.type)}${i18n.t('other.arkType')} 
  ${top ? `x ${top.type === 'H' ? 'II' : top.type}${i18n.t('other.TopArk')}` : ''} `;
};

// 尺寸格式化方法
export const sizeFomatter = (size) => {
  if (!size) { return ''; }
  const {
    top,
    bottom: { len1: bottomL1, len2: bottomL2, len3: bottomL3 },
  } = size;
  let topSizeText = '';
  // 处理底柜
  const bottomSizeText = [bottomL1,
    bottomL2, bottomL3].filter(((item) => item)).map((item) => `${item}${i18n.t('cm')}`).join('x');
  // 判断有顶柜才处理top
  if (top) {
    const { len1: topL1, len2: topL2, len3: topL3 } = top;
    topSizeText = [topL1, topL2, topL3].filter(((item) => item)).map((item) => `${item}${i18n.t('cm')}`).join('x');
  }
  return (
    <>
      <p>
        <span style={{ fontWeight: 'bold' }}>{i18n.t('other.bottom_ark')}</span>
        <span>{bottomSizeText}</span>
      </p>
      {top && (
      <p>
        <span style={{ fontWeight: 'bold' }}>{i18n.t('other.top_ark')}</span>
        <span>{topSizeText}</span>
      </p>
      )}
    </>
  );
};


const cabinetType = {
  I: 'I字型',
  L: 'L字型',
  H: 'II字型',
  U: 'U字型',
  U_S: 'U字型',
};


const bottomType = (bottom) => i18n.t('csc_text.bottom_type', { bottomType: cabinetType[bottom.type] });
const topType = (top) => i18n.t('csc_text.top_type', { topType: cabinetType[top.type] });

export const CSCText = (path, otherText, templateJson, size) => {
  if (otherText) return otherText;
  if (!templateJson?.bottom) return i18n.t('csc_text.csc_stepone');
  const { bottom, top } = templateJson;
  const currentPathArr = [
    'stepone',
    'steptwo',
    'stepthree',
    'doorPlank',
    'mesa',
    'storage',
  ];

  const {
    top: sizeTop,
    bottom: { len1: bottomL1, len2: bottomL2, len3: bottomL3 },
  } = size;

  let topSizeText = '';

  const bottomSizeText = [bottomL1, bottomL2, bottomL3]
    .filter((item) => item)
    .map((item, index) => `L${index + 1}:${item}cm`)
    .join(',');
  if (sizeTop) {
    const { len1: topL1, len2: topL2, len3: topL3 } = sizeTop;
    topSizeText = [topL1, topL2, topL3]
      .filter((item) => item)
      .map((item, index) => `L${index + 1}:${item}cm`)
      .join(',');
  }

  const commonSizeText = `${bottomType(bottom).replace('字', '')}（${bottomSizeText}）`
    + `${top ? `,${topType(top).replace('字', '')}（${topSizeText}）` : ''}`
    + `${bottom?.highAndLow ? ',高低台面' : ''}`;

  let cscText = '';
  const currPath = currentPathArr.filter((item) => path.includes(item));
  let doorText = `门板：${bottom.globalName}${bottom.validDesignText}`;
  switch (currPath[0]) {
    case 'stepone':
      cscText = i18n.t('csc_text.csc_stepone');
      break;
    case 'steptwo':
      cscText = `${i18n.t('csc_text.csc_steptwo')}${bottomType(bottom)}${top ? `,${topType(top)}` : ''}。`;
      break;
    case 'stepthree':
      cscText = `${i18n.t('csc_text.csc_stepthree')}${commonSizeText}。`;
      break;
    case 'doorPlank':
    case 'mesa':
      cscText = `${i18n.t('csc_text.csc_doorOrmesa')}${commonSizeText}。`;
      break;
    case 'storage':

      if (top?.appearanceId && top?.appearanceId !== bottom.appearanceId) {
        doorText = `底柜门板：${bottom.globalName}${bottom.validDesignText}，顶柜门板：${top.globalName}${top.validDesignText}`;
      }
      cscText = `${i18n.t('csc_text.csc_storage')}${commonSizeText}，${doorText}。`;
      break;
    default:
      break;
  }
  return cscText;
};
